<div class="home_unconnected_content_wrapper" id="homeCondWrapper">
  <div class="container-fluid" id="containerFluid">
    <h2 class="loggedin_user">
      <span i18n="@@home.loggedin-user.welcome-firstname">Welcome, {{ firstName }}</span>!
    </h2>
    <div *ngIf="!(userRole === 'srtUser')" class="home_tiles" id="homeTiles">
      <div class="card" *ngIf="(userRole === 'retailHQUser' || userRole === 'storeUser' || userRole === 'regionalHQ' || userRole === 'deviceExecutive')" id="card">
        <div class="card-header" id="cardHeader">
          <span i18n="@@home.home_tiles-device.device-connectivity">DEVICE CONNECTIVITY</span>
        </div>
        <div class="card-body" [ngClass]="totalDevicesCount?'':'d-flex'" id="cradBody">
          <div *ngIf="totalDevicesCount" [chart]="chart" id="totalDevicesCount"></div>
          <div *ngIf="!totalDevicesCount" class="no-devices" id="noDevices">
            <div class="empty-chart" id="emptyChart">
              <div class="device-count" id="deviceCount">0</div> <span i18n="@@home.device.device">Device</span>
            </div>
            <div class="no-device-text" id="noDeviceText"><span
                i18n="@@home.device-length.no-devices-have-been-connected">No devices have
                been connected</span></div>
          </div>
        </div>
        <div class="card-footer" id="cardFooter">
          <button type="button" class="btn btn-primary gtmDeviceConnect" (click)="navigateToDevices()">
            <span i18n="@@home.all-devices.view-all-devices">View All Devices</span> &nbsp;
            <em class="chevron_right"></em>
          </button>
        </div>
      </div>
      <div class="card" *ngIf="!(userRole === 'retailHQUser' || userRole === 'regionalHQ') || !isAnalyticsEnabled"
        [ngClass]="(showOrHideCard)?'change-width':''" id="showOrHideCard">
        <div class="card-header" id="cardCreateProfile">
          <span i18n="@@home.home_tiles.create-profile">CREATE A PROFILE</span>
        </div>
        <div class="card-body" [ngClass]="(showOrHideCard)?'change-height':''" id="creatProfileImg">
          <img alt="create profile"
            [ngClass]="languageCode === 'es-mx'? 'create-profile-img-es-mx' : 'create-profile-img'" />
        </div>
        <div class="card-footer" id="createProfileFooter">
          <button type="button" class="btn btn-primary gtmCreateProfile" (click)="navigateToCreateProfile()">
            <span i18n="@@home.home_tiles.create-profile-cta">Create a Profile</span> &nbsp;
            <em class="chevron_right"></em>
          </button>
        </div>
      </div>
      <!-- As part of story IIT2-958 commenting below code
        <div class="card" *ngIf="!(userRole === 'retailHQUser' || userRole === 'storeUser')">
        <div class="card-header">
          <span i18n="@@home.home_tiles.download-ipos">DOWNLOAD STANDARD IPOS</span>
        </div>
        <div class="card-body">
         
          <img
            alt="download standard ipos"
            class="img-fluid create-profile-img"
          />
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-primary gtmDwnldStdIpos">
            Download standard IPOS &nbsp;
            <em class="chevron_right"></em>
          </button>
        </div>
      </div> -->
      <div class="card" *ngIf="(userRole === 'retailHQUser' || userRole === 'regionalHQ') && isAnalyticsEnabled"
        id="cardRetail">
        <div class="card-header" id="cardHeaderAnalytics">
          <span i18n="@@home.home_tiles-analytics.analytics">ANALYTICS</span>
        </div>
        <div class="card-body" id="cardAnalyticsImg">
          <img alt="download standard ipos" class="analytics-img" />
        </div>
        <div class="card-footer" id="googleAnalyticsFooter">
          <button type="button" class="btn btn-primary gtmGaAnalytics" (click)="redirectToUrl()">
            <span i18n="@@home.google-analytics.google-analytics">Google Analytics</span> &nbsp;
            <em class="chevron_right"></em>
          </button>
        </div>
      </div>
      <div class="card" [ngClass]="(showOrHideCard)?'change-width':''" id="cardIposHelp">
        <div class="card-header">
          <span i18n="@@home.home_tiles.ipos-help">IPOS HELP</span>
        </div>
        <div class="card-body" [ngClass]="(showOrHideCard)?'change-height':''" id="cardBodyIposHelp">
          <img alt="IPOS help" [ngClass]="languageCode === 'es-mx'? 'ipos-help-img-es-mx' : 'ipos-help-img'" />
        </div>
        <div class="card-footer" id="cardFooterIposHelp">
          <button type="button" class="btn btn-primary gtmIposHelp" (click)="navigateToHelpPage()">
            <span i18n="@@home.home_tiles.ipos-help-cta">IPOS Help</span> &nbsp;
            <em class="chevron_right"></em>
          </button>
        </div>
      </div>
    </div>

    <!-- Updates Heading -->
    <div *ngIf="!(userRole === 'srtUser')" class="updates_header" id="updatesHeaders">
      <!-- <span>
        <h2> <span i18n="@@home.updates_header.updates">Updates</span></h2>
        <span class="form-check">
          <input class="form-check-input gtmHideUpdates" type="checkbox" value="" id="hideUpdates" value="isHide"
            [checked]="isHideUpdate" (click)="isHideUpdatesChecked($event)" />
          <label class="form-check-label updates-label" for="hideUpdates">
            <span i18n="@@home.updates_header.hide-updates">Hide updates until the next update</span>
          </label>
        </span>
      </span> -->
      <span>
        <!--For last Release Date-->
        <span i18n="@@home.updates_header.last-update"><strong>IPOS Last Update: </strong></span> {{timeZone.indexOf('America') === -1 ? (latestReleaseDate | date: 'dd/MMM/yyyy') :  (latestReleaseDate | date: 'MMM/dd/yyyy')}}
        <strong>| Latest IPOS Version: </strong>{{iposLegalVersion}} 
      </span>
    </div>

    <!-- Updates -->
    <ng-container *ngIf="!isHideUpdate">
      <!-- New Welcome section Implementation -->
      <div class="card update_content single-home-screen" id="cardUpdateContent">
        <img *ngIf="!(userRole === 'srtUser')" class="welcome-img" alt="welcome image">
        <img *ngIf="(userRole === 'srtUser')" class="welcome-img-srt-kiosk" alt="welcome srt kiosk image">
        <div i18n="@@home.welcome-ipos-text" *ngIf="!(userRole === 'srtUser')" class="home-screen-text" id="welcomeScreen"><span>Welcome to IPOS </span>
          <span class="home-welcome-text"></span>
          <span class="home-welcome-year">{{iposVersion}}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<iposcen-spinner-overlay *ngIf="userRole === 'regionalHQ' && showRetailGif" [isCard]="true"></iposcen-spinner-overlay>
<iposcen-spinner-overlay *ngIf="userRole === 'regionalHQ' && !showRetailGif" [isCard]="false"></iposcen-spinner-overlay>
<!----Regional Pop up-->
<div class="container" *ngIf="(userRole === 'regionalHQ' || userRole === 'srtUser') && openRegionalPopup">
  <div class="modal-backdrop show"></div>
  <div class="modal" data-backdrop="true">
    <div class="modal-dialog modal-dialog-centered" id="regionalPopup">
      <div class="modal-content regional_modal_content">
        <div class="regional_card">
          <div class="modal-header header">
            <span i18n="@@home.home_tiles-choose-account.choose-an-account">CHOOSE AN ACCOUNT</span>
          </div>
          <div class="modal-body">
            <div class="regional-subtext">
              <span *ngIf="userRole === 'regionalHQ'"
                i18n="@@home.home_tiles-regional-login-text.log-in-using-the-account-for-the-region-you-wish-to-access">Log
                in using the account for the region you wish to access</span>
              <span *ngIf="userRole === 'srtUser'">Log
                in using the account for the retail HQ you wish to access</span>
            </div>
            <div class="regional-items-list">
              <ng-container *ngFor="let regional of regionalDisplay">
                <div (click)="selectRegionalHQ(regional)" class="regional-content">
                  <div>{{regional}}</div>
                  <span class="chevron_right_black"></span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'>
</iposcen-spinner-overlay>